export default "__VITE_ASSET__SZAQNIaS__"